export function speak(text: string, lang: string = 'en-US') {
  if (!window.speechSynthesis) {
    return
  }
  const utterance = new SpeechSynthesisUtterance(text)
  utterance.lang = lang
  window.speechSynthesis.speak(utterance)
}
